import Modal from "react-bootstrap/Modal";
import { styleEnd } from "../../algorithms/styleDirection";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import TextArea from "../sharedComponents/textarea/textArea";

import { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "./formikValidation";
import Button from "../sharedComponents/buttons/button";
import "../tasks/tasksStyle.css";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { layersIconAdd } from "../reusableComponents/svgIcons";
import { useSelector } from "react-redux";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  addNewMilestone,
  getAllProjectStatus,
} from "../../API/store/actions/projects/projects";

const AddMilestone = (props) => {
  const { onHide, communityId = 6, setProjAdded, projAdded, projectId } = props;

  const [MilestoneDropdownList, setMilestoneDropdownList] = useState([]);

  const [dropdowns, setDrobdowns] = useState({});
  const userToken = useSelector((state) => state.login.userToken);

  // const [communityId, setCommunityId] = useState(6)

  useEffect(() => {
    resolver(getAllProjectStatus, setDrobdowns, userToken);
  }, []);

  useEffect(() => {
    if (dropdowns?.data?.statusLkp)
      setMilestoneDropdownList(dropdowns?.data?.statusLkp);
  }, [dropdowns]);

  const userLogged = useSelector((state) => state.login.userData);
  const [disable, setDisable] = useState(false);

  const saveHandler = async (values) => {
    const newData = {
      name: values.Name,
      projectId: projectId,
      description: values.Description,
      ownerId: userLogged.id,
      milestoneStatusId: parseInt(values.MilestoneStatusId),
    };
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res = await addNewMilestone(newData, userToken);
    if (res.status <= 206) {
      setMilestoneDropdownList(dropdowns.data.statusLkp);
      resetForm();
      onHide();
      setProjAdded(!projAdded);
      setDisable(false);
    } else {
      setDisable(false);
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      undefined,
      validationSchema,
      "addMilestone",
      saveHandler
    )
  );

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
    resetForm,
  } = formik;

  if (dropdowns?.data?.statusLkp) {
    return (
      <Modal
        // show={show}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        {...props}
        style={{ zIndex: 1000000 }}
        backdrop="static"
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex align-items-center px-4">
              <div
                style={{
                  backgroundColor: "#1A73E8",
                  height: 26,
                  width: 26,
                  cursor: "pointer",
                  borderRadius: "50%",
                }}
                className="d-flex justify-content-center text-center align-items-center itemNav plusIcon"
              >
                <div
                  style={{
                    width: 16,
                    height: 16,
                    background:
                      "url('/assets/images/icons/Path 184.png') 0% 0% no-repeat padding-box",
                    opacity: 1,
                    filter: "opacity(1) brightness(20)",
                  }}
                  className="any"
                ></div>
              </div>
              <div className="text-dark">
                <p
                  className="my-0 mx-1"
                  style={{
                    fontSize: 18,
                    textAlign: "justify",
                    color: "#1a73e8",
                  }}
                >
                  {Lang.addMilestone}
                </p>
              </div>
            </div>
          </Modal.Title>
          <div
            className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}
          >
            <Icon
              name="times"
              size={22}
              color={"#1A73E8"}
              onclick={() => {
                onHide();
                setMilestoneDropdownList(dropdowns.data.statusLkp);
                resetForm();
                setDisable(false);
              }}
            />
          </div>
        </Modal.Header>

        <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <form onSubmit={handleSubmit}>
            <TextArea
              name={"Name"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.title + "*"}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Name")}
            />

            <TextArea
              name={"Description"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.Description + "*"}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Description")}
            />

            <div className="d-flex flex-xl-row justify-content-center align-items-center col-12 flex-column mb-4">
              <DropDownList
                placeholder={Lang.status + "*"}
                border={true}
                containerStyle={"col-12 mb-3 my-xl-0 px-xl-5 px-4"}
                dataSource={MilestoneDropdownList}
                value={values.MilestoneStatusId}
                change={(e) => {
                  setFieldValue("MilestoneStatusId", e.value);
                }}
                errorMessage={formikValidation(
                  touched,
                  errors,
                  "MilestoneStatusId"
                )}
              />
            </div>

            <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
              <Button
                disable={disable}
                content={disable ? Lang.saving : Lang.save}
                containerStyle="col-3 mx-3"
                type={"submit"}
                buttonStyleType={"solid"}
              />

              <Button
                content={Lang.cancel}
                containerStyle="col-3 mx-3"
                onClick={() => {
                  onHide();
                  setMilestoneDropdownList(dropdowns.data.statusLkp);
                  resetForm();
                  setDisable(false);
                }}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  } else {
    return null;
  }
};
export default AddMilestone;
